import React from 'react';

export const getHandlerKayPress = <T extends () => void>(key: string, cb: T) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === key) {
      cb();
    }
  };
};
